export const SignalREvents = {
    RECEIVE_JD_PARSER_STATUS: "ReceiveJDParserStatus"
}